import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts"
import {
    Card,
    CardBody,
} from "reactstrap";

const LineChart = (props) => {

    const { leads } = props;
    // console.log('open array on line chart', open);
    const [months, setMonths] = useState([]);
    const [monthN, setMonthN] = useState([]);
    const [series, setSeries] = useState([
        {
            name: "Open",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            type: 'line',
        },
        {
            name: "In Process",
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0],
        }, {
            name: "Closed",
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
            name: "Rejected",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
            type: 'line',
        }]);

    useEffect(() => {
        getMonths();
        if (leads)
            modifyOpenRecords();
    }, [props]);

    const getMonths = () => {
        var d = new Date();
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var today = new Date();
        var d;
        var month;
        let temp = [], num = [];
        for (var i = 8; i > 0; i -= 1) {
            d = new Date(today.getFullYear(), (today.getMonth() + 1) - i, 1);
            month = months[d.getMonth()];
            //   console.log(month);
            temp.push(month);
            num.push(d.getMonth() + 1);
        }
        // console.log(temp);
        setMonths(temp);
        setMonthN(num);
    }

    const modifyOpenRecords = () => {
        console.log(monthN);
        let openRecord = [0, 0, 0, 0, 0, 0, 0, 0];
        let processRecord = [0, 0, 0, 0, 0, 0, 0, 0];
        let closeRecord = [0, 0, 0, 0, 0, 0, 0, 0];
        let rejectedRecord = [0, 0, 0, 0, 0, 0, 0, 0];
        monthN.map((item, index) => {
            leads?.monthlyOpen?.map((mon) => {
                if (item == mon?._id?.month)
                    openRecord[index] = mon?.count;
            });
            leads?.monthlyProcess?.map((mon) => {
                if (item == mon?._id?.month)
                    processRecord[index] = mon?.count;
            });
            leads?.monthlyClosed?.map((mon) => {
                if (item == mon?._id?.month)
                    closeRecord[index] = mon?.count;
            });
            leads?.monthlyRejected?.map((mon) => {
                if (item == mon?._id?.month)
                    rejectedRecord[index] = mon?.count;
            });
        });
        // console.log('open after modify', rejectedRecord);
        setSeries([
            {
                name: "Open",
                data: openRecord,
                type: 'line',
            }, {
                name: "In Process",
                data: processRecord,
                type: 'line',
            }, {
                name: "Closed",
                type: 'area',
                data: closeRecord,
            },

            {
                name: "Rejected",
                data: rejectedRecord,
                type: 'line',
            },

        ])
    }

    const options = {
        chart: {
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        colors: ['#3b5de7', '#ffa500', '#45cb85', '#ff715b'],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: '3',
            dashArray: [4, 0],
        },

        markers: {
            size: 3
        },
        xaxis: {
            categories: months,
            title: {
                text: 'Month'
            }
        },

        fill: {
            type: 'solid',
            opacity: [1, 0.1],
        },

        legend: {
            position: 'top',
            horizontalAlign: 'right',
        }
    }

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h4 className="card-title mb-4">Patient Report</h4>

                    <ReactApexChart
                        options={options}
                        series={series}
                        height="260"
                        type="line"
                        className="apex-charts"
                    />
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LineChart